"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Card = _interopRequireDefault(require("@mui/material/Card/Card.js"));
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent/CardContent.js"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _Avatar = _interopRequireDefault(require("@mui/material/Avatar/Avatar.js"));
var _Button = _interopRequireDefault(require("@mui/material/Button/Button.js"));
var _useTheme = _interopRequireDefault(require("@mui/material/styles/useTheme.js"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip/Tooltip.js"));
var _Chip = _interopRequireDefault(require("@mui/material/Chip/Chip.js"));
var _Build = _interopRequireDefault(require("@mui/icons-material/Build"));
var _NewReleases = _interopRequireDefault(require("@mui/icons-material/NewReleases"));
var _ArrowForwardIos = _interopRequireDefault(require("@mui/icons-material/ArrowForwardIos"));
var _Campaign = _interopRequireDefault(require("@mui/icons-material/esm/Campaign.js"));
var _CheckCircleOutline = _interopRequireDefault(require("@mui/icons-material/esm/CheckCircleOutline.js"));
var _Schedule = _interopRequireDefault(require("@mui/icons-material/esm/Schedule.js"));
var _announcementTypes = require("../types/announcementTypes");
var _announcementUtils = require("../utils/announcementUtils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AnnouncementTile = ({
  announcement,
  actionButtonText = 'Details',
  sx = {},
  isPlatformAdmin = false,
  platformEnvironments = [],
  onActionClick
}) => {
  const theme = (0, _useTheme.default)();
  const isMaintenance = announcement?.type === 'maintenance';
  const announcementType = announcement.type === _announcementTypes.SolutionAnnouncementType.Maintenance ? _announcementTypes.SolutionAnnouncementType.Maintenance : _announcementTypes.SolutionAnnouncementType.Feature;
  const formattedDates = (0, _announcementUtils.formatAnnouncementDates)(announcement.startDate, announcement.endDate, announcementType);
  let avatarContent = null;
  if (announcement.mode === _announcementTypes.AnnouncementAppMode.Platform) {
    avatarContent = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Avatar.default, {
      sx: {
        bgcolor: theme.palette.info.light,
        m: 2,
        width: 48,
        height: 48
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Campaign.default, {})
    });
  } else {
    avatarContent = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
      title: isMaintenance ? 'Maintenance' : 'Feature',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Avatar.default, {
        sx: {
          bgcolor: isMaintenance ? theme.palette.error.light : theme.palette.success.main,
          m: 2,
          width: 48,
          height: 48
        },
        children: isMaintenance ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Build.default, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_NewReleases.default, {})
      })
    });
  }
  let statusIndicator = null;
  if (announcement.mode === _announcementTypes.AnnouncementAppMode.Platform && isPlatformAdmin) {
    const platformAnnouncement = announcement;
    if (platformAnnouncement.isGenerallyAvailable) {
      statusIndicator = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip.default, {
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckCircleOutline.default, {}),
        label: "Generally Available",
        color: "success",
        variant: "outlined",
        sx: {
          mr: 1
        }
      });
    } else {
      const scopedEnvironments = platformEnvironments.filter(env => platformAnnouncement.scope.includes(env.id));
      const scopedEnvironmentNames = scopedEnvironments.map(env => env.name);
      statusIndicator = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
        title: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            maxHeight: '200px',
            overflowY: 'auto'
          },
          children: ["Available in:", /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
            style: {
              margin: '8px 0',
              paddingLeft: '16px'
            },
            children: scopedEnvironmentNames.map(name => /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
              children: name
            }, name))
          })]
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip.default, {
          icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Schedule.default, {}),
          label: "Scoped Announcement",
          variant: "outlined",
          sx: {
            mr: 1
          }
        })
      });
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.default, {
    elevation: 3,
    sx: {
      display: 'flex',
      alignItems: 'center',
      height: '100px',
      mt: 2,
      ...sx
    },
    children: [avatarContent, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CardContent.default, {
      sx: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        variant: "h6",
        noWrap: true,
        children: announcement.title
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        variant: "body2",
        sx: {
          color: 'text.secondary'
        },
        noWrap: true,
        children: formattedDates
      })]
    }), statusIndicator, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      sx: {
        mr: 2,
        color: 'text.primary'
      },
      endIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArrowForwardIos.default, {}),
      onClick: onActionClick,
      children: actionButtonText
    })]
  });
};
var _default = exports.default = AnnouncementTile;